/* Traduzir textos do formulário de prescrição */

(function() {
  'use strict';
  
  function translateTexts() {
    // Traduzir "OR" para "OU"
    const orElement = document.querySelector('.prescription_wrapper_title span');
    if (orElement && orElement.textContent.trim() === 'OR') {
      orElement.textContent = 'OU';
    }
    
    // Traduzir "No file chosen"
    const fileNameElement = document.querySelector('.upload_file_name');
    if (fileNameElement && fileNameElement.textContent.trim() === 'No file chosen') {
      fileNameElement.textContent = 'Nenhum arquivo selecionado';
    }
  }
  
  // Executar após DOM carregar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(translateTexts, 600);
    });
  } else {
    setTimeout(translateTexts, 600);
  }
  
  // Re-executar periodicamente
  setInterval(translateTexts, 1000);
  
})();
